import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import tw from 'twin.macro';
import { BiChevronRight } from 'react-icons/bi'; // 
import axios from 'axios';
import { AiOutlineStock } from "react-icons/ai";
import { LuSearchCheck } from "react-icons/lu";
const HeaderContainer = styled.div`
  ${tw`bg-white h-16 px-8 flex items-center justify-center border-b border-gray-300 shadow-sm`}
`;

const NavContainer = styled.div`
  ${tw`flex items-center space-x-8 `} 
`;

const NavItem = styled.div`
  ${tw`relative inline-block text-gray-700 text-sm font-medium cursor-pointer`}
  &:hover > div {
    ${tw`block`}
  }
`;

const DropdownMenu = styled.div`
  ${tw`hidden absolute left-0 mr-0 w-auto min-w-[150px] max-w-[400px] bg-white border border-gray-300 rounded-xl shadow-lg`}
  z-index: 1000; /* Ensure it has a higher z-index value */
`;

const DropdownItem = styled.div`
  ${tw`px-4 py-2 text-gray-700 cursor-pointer hover:bg-gray-100 relative w-full whitespace-nowrap`}
  z-index: 1001; /* Ensure it is above the dropdown menu itself if needed */

  &:hover > div {
    ${tw`block`}
  }
`;

const FlexContainer = styled.span`
  ${tw`flex items-center justify-between`}
`;

const NestedDropdownMenu = styled.div`
  ${tw`hidden absolute left-auto top-0 ml-32 w-auto min-w-[150px] max-w-[400px] bg-white border border-gray-300 rounded-xl shadow-lg`}
  z-index: 1002; /* Ensure it is above the parent dropdown menu */
`;

const ArrowIcon = styled.span`
  ${tw`ml-1 text-black`}
  font-size: 18px; /* Adjust the size of the icon */
  display: inline-block; /* Ensure it aligns horizontally with text */
  vertical-align: middle; /* Align vertically with text */
`;

const IconWrapper = styled.div`
  ${tw`rounded-full h-12 w-12 flex items-center justify-center`}
`;

const NavIconWrapper = styled.div`
  ${tw`rounded-full h-12 w-12 flex items-center justify-center`}
`;
export default function Header() {
  const [stockScannerMenu, setStockScannerMenu] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchStockScannerMenu = async () => {
      try {
        let res = await axios.get("http://194.163.130.200:8080/StockScanner/GetStockScannerMenu")
        let unique = [...new Set(res.data.map(item => item.catName))]
        console.log(unique)
        setStockScannerMenu(res.data)
      } catch (e) {
        console.error(e);
      }
    }
    fetchStockScannerMenu()
  }, [])

  return (
    <HeaderContainer>
      <NavContainer>
        {/* Market Dropdown */}
        <NavItem>
          <FlexContainer>
            <IconWrapper className="">
            <AiOutlineStock className="flex justify-end text-black" />

            </IconWrapper>
            Market
          </FlexContainer>
          <DropdownMenu>
            <DropdownItem onClick={() => navigate('/layout/global-indices')}>Global Indices</DropdownItem>
            <DropdownItem onClick={() => navigate('/layout/indian-indices')}>Indian Indices</DropdownItem>
            <DropdownItem>
              <FlexContainer>
                Index Summary
                <ArrowIcon>
                  <BiChevronRight />
                </ArrowIcon>
              </FlexContainer>
              <NestedDropdownMenu>
                <DropdownItem onClick={() => navigate('/layout/nifty-50')}>Nifty50</DropdownItem>
                <DropdownItem onClick={() => navigate('/layout/bank-nifty')}>Bank Nifty</DropdownItem>
                <DropdownItem onClick={() => navigate('/layout/fin-nifty')}>Fin Nifty</DropdownItem>
                <DropdownItem onClick={() => navigate('/layout/midcap-select')}>Mid Cap Select</DropdownItem>
                <DropdownItem onClick={() => navigate('/layout/sensex')}>Sensex</DropdownItem>
                <DropdownItem onClick={() => navigate('/layout/bankex')}>BankEx</DropdownItem>
              </NestedDropdownMenu>
            </DropdownItem>
            <DropdownItem onClick={() => navigate('/layout/commodity')}>Commodity</DropdownItem>
            <DropdownItem onClick={() => navigate('/layout/indian-adr')}>Indian ADR</DropdownItem>
            <DropdownItem onClick={() => navigate('/layout/global-currency')}>Global Currency</DropdownItem>
          </DropdownMenu>
        </NavItem>

        {/* Stock Scanner Dropdown */}
        <NavItem>
        <FlexContainer>
            <IconWrapper className="">
            <LuSearchCheck  className="flex justify-end text-black" />
            </IconWrapper>
            Stocks Scanner
          </FlexContainer>
          
          <DropdownMenu>
            {[...new Set(stockScannerMenu?.map((item) => item.catName))]?.map((catName, index) => (
              <DropdownItem key={index}>
                <FlexContainer>
                  {catName}
                  <ArrowIcon>
                    <BiChevronRight />
                  </ArrowIcon>
                </FlexContainer>
                <NestedDropdownMenu>
                  {stockScannerMenu
                    ?.filter((item) => item.catName === catName)
                    ?.map((item, index) => (
                      <DropdownItem key={index} onClick={() => navigate(`/menu2/${catName}/${item.scannerName}`)}>
                        {item.scannerName}
                      </DropdownItem>
                    ))}
                </NestedDropdownMenu>
              </DropdownItem>
            ))}
          </DropdownMenu>
        </NavItem>
      </NavContainer>
    </HeaderContainer>
  );
}
